module.exports = __webpack_public_path__ + "img/entry_night.9bd7e722.svg";